import {FC, useContext} from 'react'
import {Booking} from '../../../modules/apps/booking/list/core/_models'
import {KTSVG} from '../../../../_metronic/helpers'
import {BookingContext} from '../Page'

const FetchModalHeader: FC<{booking: Booking | undefined}> = ({booking}) => {
  const {setShow} = useContext(BookingContext)
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>
        View Booking{' '}
        {booking?.status === false ? (
          <span className='badge badge-light-danger fw-bolder'>Draft</span>
        ) : booking?.completed ? (
          <span className='badge badge-light-success fw-bolder'>Completed</span>
        ) : (
          <span className='badge badge-light-primary fw-bolder'>Pending</span>
        )}
      </h2>
      {/* end::Modal title */}

      {/* begin::Edit */}
      <div>
        {/* begin::Close */}
        <div
          className='btn btn-icon btn-sm btn-active-icon-primary'
          data-kt-bookings-modal-action='close'
          onClick={() => setShow(false)}
          style={{cursor: 'pointer'}}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>
      </div>
      {/* end::Close */}
    </div>
  )
}

export {FetchModalHeader}
